import { GetServerSidePropsContext } from 'next'

const avoidRegexp = /[^A-Za-zÀ-ÖØ-öø-ÿ\u0621-\u064A0-9-.]+/g
const replaceWithDashRegexp = /[\s_]/g

const shouldRedirect = (str: string) =>
  str !== str.toLowerCase() ||
  new RegExp(avoidRegexp).test(str) ||
  new RegExp(replaceWithDashRegexp).test(str) ||
  decodeURIComponent(str) !== str

const findPageRedirectMiddleware = (ctx: GetServerSidePropsContext) => {
  const { query, res, locale } = ctx
  const pathList = query.search as string[]
  if (pathList.some((path) => shouldRedirect(path))) {
    res.writeHead(301, {
      Location: `/${locale}/find/${pathList
        .map((path) =>
          decodeURIComponent(path).replace(replaceWithDashRegexp, '-').replace(avoidRegexp, '').toLowerCase()
        )
        .join('/')}`
    })
    res.end()
    return {
      props: {
        errorCode: 301
      }
    }
  }
}

export default findPageRedirectMiddleware
